/** ESCHER FALLS — English. */

import type { Strings } from './ja';

export const EN: Strings = {
  pour: 'Release',
  lever: 'Lever',
  leverAria: 'Pull the lever',
  retry: 'Restart',
  again: 'Again',
  next: 'Next',
  share: 'Share this',
  shareFailed: 'Could not share',
  rotateLeft: 'Rotate view left',
  rotateRight: 'Rotate view right',
  tiltUp: 'Raise the view',
  tiltDown: 'Lower the view',
  topDown: 'Top-down',
  water: (left, total) => `Water ${left} / ${total}`,
  moves: (left, total) => `Moves ${left} / ${total}`,
  timeLeft: (time) => `${time} left`,
  drops: (n) => `${n} drops`,

  resultClear: 'It flowed',
  resultFail: 'It did not flow',
  clearTitle: 'Flowed',
  fail: {
    time: 'Time ran out',
    moves: 'No moves left',
    drywell: 'It ran into the dry well',
    water: 'The water ran out',
    deadend: 'The water fell into a dead end',
  },
  extendByAd: 'Watch an ad for 30 more seconds',
  extendByDrops: (cost) => `${cost} drops for 30 more seconds`,
  multiplyByAd: (mult) => `Watch an ad for ×${mult} drops`,

  stages: 'Stages',
  settingsAria: 'Settings',
  menuAria: 'Menu',
  back: 'Back',
  loop1: 'First pass',
  loop2: 'Second pass',
  loopNote: 'The second pass tightens moves and time. Its records are kept apart.',
  shop: 'Shop',
  groupMain: 'Main',
  groupExtra1: 'Extras',
  groupExtra2: 'Extras II',
  freeTrial: 'Free',
  notPurchased: (n, name) => `${n} ${name} (locked)`,
  lockedStage: 'Locked stage',
  extraLockedFree: 'Stage 1, “The Upward Fall”, is free. The rest open with a purchase from Settings (≡).',
  extraLocked: 'Opens with a purchase from Settings (≡).',
  extra2Locked: 'Stages 11 onward open once stages 1–10 have all flowed.',
  extra2LockedUnowned: 'Purchase from Settings (≡), then clear stages 1–10 to open stage 11 onward.',
  extra2Note: 'Opens once every Extra has flowed.',
  progress: (cleared, total) => `Main ${cleared} / ${total} flowed`,
  totalTime: (time) => `Total ${time}`,
  totalNone: 'Total —',

  settings: 'Settings',
  bgm: 'Ambience',
  se: 'Effects',
  testSound: 'Test sound',
  audioStatus: (state) => `Sound: ${state}`,
  audioState: {
    locked: 'Locked (touch the screen once to wake it)',
    running: 'Running',
    suspended: 'Paused',
  },
  demoNote: (n) => `These ${n} stages are the free web demo. All 42 are in the app.`,
  demoGet: 'Get it on the App Store',
  // — 今日の一面（日替わり）
  dailyTitle: 'Today\'s stage',
  dailyLoading: 'Loading…',
  dailyOffline: 'Can\'t reach the server, so today\'s stage can\'t open',
  dailyPlay: 'Play',
  dailyCleared: (time: string) => `Flowed in ${time}`,
  archiveTitle: 'Past stages',
  upcomingTitle: 'Upcoming stages',
  archiveLocked: 'The last 3 days are free. Buy the Extras to open every earlier stage',
  language: 'Language',
  languageAuto: 'Follow the device',
  palette: 'Palette',
  worn: 'In use',
  owned: 'Owned',
  buyDrops: 'Buy drops',
  restore: 'Restore purchases',
  writeReview: 'Rate this app',
  moreApps: 'More by this developer',
  restoreChecking: 'Checking…',
  restoreDone: (n) => `Restored ${n}`,
  restoreNone: 'Nothing to restore',
  restoreFailed: 'Could not restore',
  chooseStage: 'Choose a stage',
  resume: 'Resume',

  prizeLabel: 'Reward',
  awardLabel: 'Title',
  toExtra: 'To the Extras',
  toLoop2: 'To the second pass',
  toStart: 'To the beginning',
  allClearTitle: 'Traversed',
  allClearBody: (n) => `Water has flowed through all ${n} channels`,
  multiplyTimes: (mult) => `Watch an ad for ×${mult}`,
  noteRank: 'The title is kept. It shows above the stage list.',
  noteLoop2: 'The second pass is open. Moves and time are tighter.',
  notePartOne: 'That is Part One. The water has not yet climbed.',
  inviteTry: 'Try Extra 1',
  inviteOpen: 'Open Extras I — 20 stages',
  dateLine: (d) =>
    `${['January','February','March','April','May','June','July','August','September','October','November','December'][d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`,

  completionTitle: 'Who Crossed the Endless',
  rank: {
    none: '—',
    sovereign: 'Sovereign of Water',
    architect: 'Architect of Falls',
    mason: 'Stonemason',
    apprentice: 'Apprentice',
    wayfarer: 'Wayfarer',
  },

  skin: {
    hakushi: 'Blank Paper',
    ai: 'Indigo',
    koke: 'Moss',
    shu: 'Vermilion',
    sumi: 'Sumi Ink',
  },

  product: {
    drops600: '600 drops',
    drops1600: '1,600 drops',
    drops5000: '5,000 drops',
    noads: 'Remove ads',
    extras: 'Extras I — 21 stages (ad-free)',
  },
};
